export interface SpaceshipMuzzleFlashPick {
  readonly key: string;
  readonly rotation: number;
  readonly tint: number;
  readonly alpha: number;
  readonly startScale: number;
  readonly endScale: number;
  readonly duration: number;
}

interface SpaceshipMuzzleFlashProfile {
  readonly key: string;
  readonly tint: number;
  readonly alpha: number;
  readonly startScale: number;
  readonly endScale: number;
  readonly duration: number;
}

const MUZZLE_FLASH_SCALE = 0.5;

const DEFAULT_PROFILE: SpaceshipMuzzleFlashProfile = {
  key: "muzzle_flash_white",
  tint: 0xf8f0d0,
  alpha: 0.86,
  startScale: MUZZLE_FLASH_SCALE,
  endScale: 1.22 * MUZZLE_FLASH_SCALE,
  duration: 96,
};

const SPACESHIP_MUZZLE_FLASH_PROFILES: Readonly<Record<string, SpaceshipMuzzleFlashProfile>> = {
  pioneer: DEFAULT_PROFILE,
  ranger: {
    key: "muzzle_flash_burst",
    tint: 0xffc45f,
    alpha: 0.94,
    startScale: MUZZLE_FLASH_SCALE,
    endScale: 1.48 * MUZZLE_FLASH_SCALE,
    duration: 124,
  },
  helios: {
    key: "muzzle_flash_star",
    tint: 0x67f4ff,
    alpha: 0.96,
    startScale: MUZZLE_FLASH_SCALE,
    endScale: 1.62 * MUZZLE_FLASH_SCALE,
    duration: 132,
  },
  xenoframe: {
    key: "muzzle_flash_spike",
    tint: 0xa875ff,
    alpha: 0.95,
    startScale: MUZZLE_FLASH_SCALE,
    endScale: 1.55 * MUZZLE_FLASH_SCALE,
    duration: 138,
  },
  astral: {
    key: "muzzle_flash_white",
    tint: 0xff83e8,
    alpha: 0.98,
    startScale: MUZZLE_FLASH_SCALE,
    endScale: 1.82 * MUZZLE_FLASH_SCALE,
    duration: 150,
  },
};

export function pickSpaceshipMuzzleFlash(
  spaceshipId: string | undefined,
  rng: () => number,
): SpaceshipMuzzleFlashPick {
  const profile = spaceshipId ? SPACESHIP_MUZZLE_FLASH_PROFILES[spaceshipId] ?? DEFAULT_PROFILE : DEFAULT_PROFILE;
  return {
    ...profile,
    rotation: rng() * Math.PI * 2,
  };
}
